export class DepartmentModel{
    deptName:string;
    deptId :number;
    constructor(deptName:string,deptId :number){
  
        this.deptName = deptName;
        this.deptId =deptId;
    }
}